/**
 * EmailJS Configuration
 * 
 * Bu dosyada EmailJS yapılandırma bilgilerini ekleyin.
 * EmailJS hesabınızdan aldığınız bilgileri buraya yapıştırın.
 * 
 * EmailJS Kurulum:
 * 1. https://www.emailjs.com/ adresinden ücretsiz hesap oluşturun
 * 2. Email servisinizi bağlayın (Gmail önerilir)
 * 3. Email template'leri oluşturun
 * 4. Service ID, Template ID ve Public Key'i buraya ekleyin
 */

// EmailJS Service ID - Email servisinizin ID'si
export const EMAILJS_SERVICE_ID = 'service_hhqh49f';

// EmailJS Template ID - Newsletter (Subscription) için template ID
export const EMAILJS_TEMPLATE_ID = 'template_7sg2bfu';

// EmailJS Template ID - Contact form için template ID
export const EMAILJS_TEMPLATE_ID_CONTACT = 'template_m51m7ap';

// EmailJS Public Key - Hesabınızın public key'i
export const EMAILJS_PUBLIC_KEY = 'xpWtCwd1ROe96TmBA';

// Alıcı email adresi
export const RECIPIENT_EMAIL = 'support@nqcagency.com';

